export default {"src":"/_next/static/media/visa.dca0856d.svg","height":16,"width":43,"blurWidth":0,"blurHeight":0};